<template>
  <log-quick-submit
    v-model="taskText"
    :placeholder="$t('ACTIVITY.TASK.TASK_DESCRIPTION')"
    :loading="isLoading"
    data-cy="task-text-edit"
    class="quick-submit-form"
  >
    <template #actionBar>
      <div />
    </template>
    <template #buttons>
      <modal-buttons
        class="max-h-8 px-0"
        :disabled="!taskText.trim() || isLoading"
        :on-cancel="() => emit('cancel')"
        :on-save="() => emit('submit', taskText)"
      />
    </template>
  </log-quick-submit>
</template>
<script setup lang="ts">
import { ref } from "vue";

import LogQuickSubmit from "@/components/communicationLogs/forms/LogQuickSubmit.vue";
import ModalButtons from "@/components/ui/ModalButtons.vue";

const { text, isLoading = false } = defineProps<{
  text: string;
  isLoading: boolean;
}>();
const emit = defineEmits<{ submit: [string]; cancel: [] }>();

const taskText = ref(text);
</script>
